export { ImageGallery } from './ImageGallery';
export type { GalleryImage, ImageGalleryProps } from './ImageGallery.types';
